<template>
    <modal-base :pacifier="false">
        <template #title>Call Failed</template>

        <template #subtitle>Please re-enter your phone number:</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card', 'form');
        }
    }
</script>
